// Build a nested customer order snapshot (mirrors scripts/customerBackfillLib).
// Pure — used by CustomerSyncService so live orders populate Recent Orders.

const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0; };
export const sanitizeOrderId = (id) => String(id).replace(/[.#$[\]/]/g, '_');

const extractAmount = (o = {}) => {
    const paths = [o.payment?.total, o.total, o.amount, o.payment?.amount, o.grandTotal, o.orderValue, o.price];
    for (const p of paths) { const n = Number(p); if (Number.isFinite(n) && n !== 0) return n; }
    for (const p of paths) { const n = Number(p); if (Number.isFinite(n)) return n; }
    return 0;
};

const buildItems = (o = {}) => {
    const arr = o.items || o.products || [];
    if (Array.isArray(arr) && arr.length) {
        return arr.map(it => ({
            productId: it.sku || it.productId || '',
            productName: it.name || it.productName || it.itemName || 'Unknown Product',
            sku: it.sku || it.productId || '',
            quantity: num(it.qty ?? it.quantity ?? 1) || 1,
            price: num(it.price ?? it.priceAfterTax ?? 0),
            total: num(it.total ?? (num(it.price) * num(it.qty ?? it.quantity ?? 1))),
        }));
    }
    return [];
};

export const buildOrderSnapshot = (order = {}, fbKey = '', syncedAt = Date.now()) => {
    const orderId = order.id || fbKey || '';
    const items = buildItems(order);
    const amount = extractAmount(order);
    const c = order.customer || {};
    const productNames = items.map(i => i.productName).filter(Boolean);
    return {
        orderId: String(orderId),
        firebaseOrderKey: String(fbKey || orderId),
        orderDate: order.orderDate || order.createdAt || '',
        createdAt: order.createdAt || '',
        customerName: c.name || order.name || '',
        mobile: c.mobile || order.mobile || '',
        amount, total: amount, orderValue: amount,
        paymentMode: order.payment?.mode || order.paymentMode || '',
        status: order.status || '',
        items,
        productNames,
        productSummary: items.map(i => `${i.productName} x${i.quantity}`).join(', '),
        courier: order.shipping?.courierPreference || order.shipping?.courier || order.courier || '',
        awb: order.shipping?.awb || order.awb || '',
        source: order.source || 'app',
        syncedAt,
    };
};
